import { apiClient } from '../api/apiClient'

// SignIn
export type SignInData = {
  email: string
  magicToken: string
  enrollmentSource?: string
}

export type SignInResponse = {
  access: string
  refresh: string
}

export const signInRequest = async ({ email, magicToken, enrollmentSource }: SignInData) => {
  if (!magicToken) throw new Error('Auth token missing')

  // Omit enrollmentSource when absent so older backends / payloads stay identical
  const body: { email: string; enrollmentSource?: string } = { email }
  if (enrollmentSource) {
    body.enrollmentSource = enrollmentSource
  }

  return apiClient.post<SignInResponse, SignInResponse>(
    '/passwordless',
    body,
    { headers: { Authorization: `Bearer ${magicToken}` } }
  )
}

export type InviteResolveData = {
  inviteToken: string
  trackLanding?: boolean
}

export type InviteResolveResponse = {
  valid: boolean
  email: string | null
  enrollmentSource: string | null
  campaign: string | null
  tracked: boolean
}

/** Resolve encrypted invite token → email/source (and track landing). */
export const resolveInviteTokenRequest = async (payload: InviteResolveData) => {
  return apiClient.post<InviteResolveResponse, InviteResolveResponse>('/invite/resolve', {
    inviteToken: payload.inviteToken,
    trackLanding: payload.trackLanding !== false,
  })
}

// TODO: remove when BE deliver workaround for apple review and history data will be available on users accounts not only on test
export const signInRequestOtp = async ({
  email,
}: Pick<SignInData, 'email'>): Promise<SignInResponse> => {
  let cred: SignInResponse = { access: '', refresh: '' }
  await apiClient.post('/sign-in', { email }).then(async () => {
    const { access, refresh } = await apiClient.post<SignInResponse, SignInResponse>(
      '/verify-otp',
      { email, code: '123456' }
    )

    cred = { access, refresh }
  })
  return cred
}
